/**
 * Helper centralizzato per logout con redirect al portale partner (se presente).
 * Legge ref_channel da sessionStorage prima di pulirlo.
 */
export function getLogoutUrl() {
  const ref = sessionStorage.getItem('ref_channel');
  return ref ? `/?ref=${encodeURIComponent(ref)}` : '/';
}

export function clearSessionAndRedirect() {
  const url = getLogoutUrl();
  sessionStorage.removeItem('access_token');
  sessionStorage.removeItem('refresh_token');
  sessionStorage.removeItem('ref_channel');
  sessionStorage.removeItem('token');
  window.location.href = url;
}
